import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const scopeModelAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: "scopeModelAPI",
    endpoints: (builder) => ({

        getAllDITypes: builder.query({
            query: (data) => ({
                url: `/ScopeModel/GetAllDiTypes?pbIncludeBlank=${data}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addScopeTypes: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/AddScopeTypes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScopeTypeDetailsById: builder.query({
            query: (plScopeTypeKey) => ({
                url: `/ScopeModel/GetScopeTypeDetailsById?plScopeTypeKey=${plScopeTypeKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllScopeModelCategories: builder.query({
            query: (data) => ({
                // url: `/ScopeModel/GetAllScopeModelCategories`,
                url: `/ScopeModel/GetAllScopeModelCategories?pbIncludeBlank=${data.pbIncludeBlank}&psInstrumentType=${data.psInstrumentType}&pbIncludeInactive=${data.pbIncludeInactive}&plScopeTypeKey=${data.plScopeTypeKey}&pbIncludeOther=${data.pbIncludeOther}&psScopeTypeCategory=${data.psScopeTypeCategory}&psDiameter=${data.psDiameter}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllvideoImagesList: builder.query({
            query: (data) => ({
                url: `/ScopeModel/GetAllvideoImagesList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScopeTypeGetAverageDaysSinceLastIn: builder.query({
            query: (data) => ({
                url: `/ScopeModel/GetScopeTypeGetAverageDaysSinceLastIn`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllManufacturersList: builder.query({
            query: (data) => ({
                url: `/ScopeModel/GetAllManufacturersList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getscopeTypeEpoxySizeRollingAvg: builder.query({
            query: (data) => ({
                url: `/ScopeModel/GetscopeTypeEpoxySizeRollingAvg`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addUpdateScopeType: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/AddUpdateScopeType`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addScopeTypeRepairItems: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/AddScopeTypeRepairItems`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateScopeTypeRepairItems: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/UpdateScopeTypeRepairItems`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteScopeTypeRepairItems: builder.mutation({
            query: (plScopeTypeRepairItemKey) => ({
                url: `/ScopeModel/DeleteScopeTypeRepairItems?plScopeTypeRepairItemKey=${plScopeTypeRepairItemKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScopeTypeRepairItem: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/GetScopeTypeRepairItem`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScopeTypeRepairItemInventory: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/GetScopeTypeRepairItemInventory`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteScopeTypeRepairItemInventoryUnlink: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/DeleteScopeTypeRepairItemInventoryUnlink?plScopeTypeRepairItemKey=${data.plScopeTypeRepairItemKey}&plInventorySizeKey=${data.plInventorySizeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScopeTypeRepairItemAvailableInventory: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/GetScopeTypeRepairItemAvailableInventory`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addScopeTypeRepairItemInventoryLink: builder.mutation({
            query: (data) => ({
                url: `/ScopeModel/AddScopeTypeRepairItemInventoryLink`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useLazyGetAllDITypesQuery,
    useAddScopeTypesMutation,
    useLazyGetScopeTypeDetailsByIdQuery,
    useLazyGetAllScopeModelCategoriesQuery,
    useLazyGetAllvideoImagesListQuery,
    useGetScopeTypeGetAverageDaysSinceLastInQuery,
    useGetscopeTypeEpoxySizeRollingAvgQuery,
    useLazyGetAllManufacturersListQuery,
    useAddUpdateScopeTypeMutation,
    useAddScopeTypeRepairItemsMutation,
    useUpdateScopeTypeRepairItemsMutation,
    useDeleteScopeTypeRepairItemsMutation,
    useGetScopeTypeRepairItemMutation,
    useGetScopeTypeRepairItemInventoryMutation,
    useDeleteScopeTypeRepairItemInventoryUnlinkMutation,
    useGetScopeTypeRepairItemAvailableInventoryMutation,
    useAddScopeTypeRepairItemInventoryLinkMutation } = scopeModelAPI;

export default scopeModelAPI;